/**
 * Created by pajicv on 10/5/18.
 */

import { compose } from 'redux';
import { connect } from 'react-redux';
import { firebaseConnect, populate } from 'react-redux-firebase';
import TaskButton from './TaskButton';
import { spinnerWhileLoading } from '../../utils/components';

const populates = [{
    child: 'subTasks',
    root: 'subTasks'
}];

const enhance = compose(
    firebaseConnect((props) => {
        const { id } = props;
        return [{ path: `tasks/${id}` }];
    }),
    connect(
        (state, props) => {
            const { id } = props;
            return ({
                task: populate(state.firebase, `tasks/${id}`, []),
                taskId: id
            });
        }
    )
);

export default enhance(TaskButton);



// WEBPACK FOOTER //
// ./src/components/common/TaskButton.enhancer.js